module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-blog-posts-list-container"
  }, [(_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('section', {
    staticClass: "c-blog-posts-list",
    class: {
      compact: _vm.compact
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "c-blog-posts-list__list"
  }, _vm._l((_vm.posts), function(post) {
    return (post && !post.sticky) ? _c('li', {
      staticClass: "c-blog-posts-list__item"
    }, [_c('h3', {
      staticClass: "c-blog-posts-list__title"
    }, [_c('router-link', {
      key: post.slug,
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/blog/' + post.slug : '/blog/' + post.slug
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(post.title) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('span', {
      staticClass: "c-blog-posts-list__date"
    }, [_vm._v(_vm._s(post.transformedDate))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(post.abstract)
      }
    }), _vm._v(" "), _c('router-link', {
      key: post.slug,
      staticClass: "c-blog-posts-list__link",
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/blog/' + post.slug : '/blog/' + post.slug
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.localizedReadMoreText) + "\n\t\t\t\t\t")])], 1) : _vm._e()
  })), _vm._v(" "), (_vm.button === 'allPosts') ? _c('router-link', {
    staticClass: "c-blog-posts-list__button",
    attrs: {
      "to": _vm.settings.currentLang === 'en-us' ? '/en/blog/' : '/blog/'
    }
  }, [_vm._v(_vm._s(_vm.localizedAllPostsText))]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b640ae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogPostsList.vue
// module id = 274
// module chunks = 0